"use client";

import Link from "next/link";
import { AuthLocaleRoot } from "@/components/i18n/auth-locale-root";
import { SkipToMain } from "@/components/accessibility/skip-to-main";
import { SiteHeader } from "@/components/marketing/site-header";
import { SiteFooter } from "@/components/marketing/site-footer";
import { ContactSupportForm } from "@/components/help/contact-support-form";
import { useLocaleContext } from "@/components/i18n/locale-context";

function MarketingContactContent() {
  const { t } = useLocaleContext();

  return (
    <div className="min-h-screen bg-slate-100 font-sans text-slate-900 antialiased">
      <SkipToMain />
      <SiteHeader variant="default" />
      <main id="main-content" className="mx-auto max-w-xl px-4 py-12 sm:py-16">
        <nav className="mb-8 text-sm text-slate-600">
          <Link href="/" className="hover:text-slate-900 hover:underline">
            ← Home
          </Link>
        </nav>
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{t("marketing.contact.pageTitle")}</h1>
          <p className="mt-2 text-sm leading-relaxed text-slate-600">{t("marketing.contact.pageSubtitle")}</p>
          <div className="mt-8">
            <ContactSupportForm source="contact-public" forceGuest />
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

/** Public contact page wrapper (locale cookie + translations). */
export function MarketingContactPage() {
  return (
    <AuthLocaleRoot>
      <MarketingContactContent />
    </AuthLocaleRoot>
  );
}
